import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  container: {
    marginBottom: theme.spacing(1),
    border: 'none',
    background: 'transparent',
    borderRadius: 0,
    overflow: 'visible',
  },
  header: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    cursor: 'pointer',
    userSelect: 'none',
    padding: theme.spacing(0.25, 0),
    '&:hover $headerTitle': {
      color: theme.palette.text.primary,
    },
  },
  chevron: {
    color: theme.palette.text.disabled,
    transition: 'transform 0.2s ease',
    transform: 'rotate(-90deg)',
    display: 'block',
  },
  chevronExpanded: {
    transform: 'rotate(0deg)',
  },
  headerTitle: {
    fontSize: 13,
    fontWeight: 400,
    color: theme.palette.text.secondary,
    lineHeight: 1.4,
  },
  stepsList: {
    paddingLeft: 0,
    paddingTop: theme.spacing(0.5),
  },
}))

export default styles
